import "../Card/Card.css";
import "./ExpandableCard.css";

import { ReactNode } from "react";

import { RightArrowOrangeIcon } from "../../../assets";
import { Align, Card, Column, Row } from "../..";
import { CardProps } from "../Card/CardProps";
import { ImageButton } from "./components";

interface ExpandableCardProps extends CardProps {
  title: string;
  targetRoute?: string;
  contentAlignment?: Align;
  tooltip?: ReactNode;
  /** Controls rendered at the right of the card header, beside (or instead of) the "View more" link. */
  headerActions?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: any;
}

export const ExpandableCard = ({
  title,
  targetRoute,
  contentAlignment = "start",
  height,
  corners = "default",
  children,
  tooltip,
  headerActions,
  state,
}: ExpandableCardProps): JSX.Element => {
  return (
    <Card height={height} corners={corners}>
      <Row
        justify="between"
        className={`ExpandableCardHeader ${headerActions ? "ExpandableCardHeader_withActions" : ""}`}
      >
        <Column span={6}>
          <div>
            <h3>{title}</h3>
            <div>{tooltip}</div>
          </div>
        </Column>
        <Column span={6} className="ExpandableCardHeaderImageButton">
          {headerActions}
          {targetRoute && (
            <ImageButton icon={<RightArrowOrangeIcon />} route={targetRoute} linkText="View more" state={state} />
          )}
        </Column>
      </Row>
      <Row align={contentAlignment} className="ExpandableCardContent">
        <Column span={12}>{children}</Column>
      </Row>
    </Card>
  );
};
